import "../css/header.scss";
import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "./CartContext";
import productData from "../Datas/productData";

function Header() {
  const { cartItems } = useContext(CartContext);

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const totalPrice =
    cartItems?.reduce((total, item) => {
      const product = productData.find((entry) => entry.id === item.id);
      return total + (product ? Number(product.price) * item.quantity : 0);
    }, 0) || 0;
  const totalItems =
    cartItems?.reduce((total, item) => total + item.quantity, 0) || 0;

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="header-center">
          <Link to="/" onClick={toTop} className="logo-link">
            <img
              src="/head/pawluna-logo.png"
              alt="Pawluna"
              className="brand-logo"
            />
          </Link>
          <div className="logo-subtext">
            Designed for enrichment · Free delivery on eligible orders over $40
          </div>
        </div>

        <div className="header-right">
          <div className="cart-wrapper">
            <div className="cart-badge">{totalItems}</div>
            <Link to="/cartpage" onClick={toTop} className="cart-icon-wrapper">
              <i className="fa-solid fa-bag-shopping"></i>
            </Link>
          </div>
          <div className="cart-total">${totalPrice.toFixed(2)}</div>
        </div>
      </div>

      <nav className="header-bottom">
        <ul className="nav-list">
          <li>
            <Link to="/" onClick={toTop}>
              Home
            </Link>
          </li>
          <li>
            <Link to="/shop" onClick={toTop}>
              Shop All
            </Link>
          </li>

          <li>
            <Link to="/about" onClick={toTop}>
              About us
            </Link>
          </li>
          <li>
            <Link to="/contact" onClick={toTop}>
              Contact us
            </Link>
          </li>
          <li className="more-nav-item">
            <details>
              <summary>More</summary>
              <div className="more-menu">
                <Link to="/faqs" onClick={toTop}>FAQs</Link>
                <Link to="/privacy" onClick={toTop}>Privacy Policy</Link>
                <Link to="/cookies" onClick={toTop}>Cookie Policy</Link>
                <Link to="/terms" onClick={toTop}>Terms &amp; Conditions</Link>
                <Link to="/returns" onClick={toTop}>Returns Policy</Link>
                <Link to="/shipping" onClick={toTop}>Delivery</Link>
              </div>
            </details>
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
